import { Card, CardContent } from "@/shared/ui/cards/card";
import { Skeleton } from "@/shared/ui/data-display/skeleton";

export const TournamentCardSkeleton = () => {
  return (
    <Card className="gap-0 py-0 p-0 overflow-hidden flex flex-col h-full">
      {/* Banner Skeleton */}
      <div className="relative h-40 w-full overflow-hidden bg-muted">
        <Skeleton className="h-full w-full" />
      </div>

      <CardContent className="flex-1 min-h-0 flex flex-col gap-4 pb-4 pt-4 px-4">
        {/* Title & Description */}
        <div className="space-y-2">
            <Skeleton className="h-6 w-3/4 rounded" />
            <Skeleton className="h-4 w-full rounded" />
            <Skeleton className="h-4 w-5/6 rounded" />
        </div>
        
        {/* Metrics Grid */}
        <div className="grid grid-cols-2 gap-3">
          <div className="flex items-center gap-2">
             <Skeleton className="h-4 w-4 rounded-full" />
             <div className="space-y-1 flex-1">
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-1.5 w-full rounded-full" />
             </div>
          </div>
          <div className="flex items-center gap-2">
             <Skeleton className="h-4 w-4 rounded-full" />
             <div className="space-y-1 flex-1">
                <Skeleton className="h-3 w-12" />
                <Skeleton className="h-4 w-16" />
             </div>
          </div>
          <div className="flex items-center gap-2">
             <Skeleton className="h-4 w-4 rounded-full" />
             <div className="space-y-1 flex-1">
                <Skeleton className="h-3 w-12" />
                <Skeleton className="h-4 w-16" />
             </div>
          </div>
          <div className="flex items-center gap-2">
             <Skeleton className="h-4 w-4 rounded-full" />
             <div className="space-y-1 flex-1">
                <Skeleton className="h-3 w-12" />
                <Skeleton className="h-4 w-16" />
             </div>
          </div>
        </div>

        {/* Organizer (Optional space) */}
        <div className="pt-3 border-t mt-auto">
             <div className="flex items-center gap-2">
               <Skeleton className="h-5 w-5 rounded-full" />
               <Skeleton className="h-3 w-24 rounded" />
             </div>
        </div>

        {/* Actions */}
        <div className="pt-2">
          <div className="flex gap-2">
            <Skeleton className="h-9 flex-1 rounded" />
            <Skeleton className="h-9 flex-1 rounded" />
          </div>
          <Skeleton className="h-3 w-32 mx-auto mt-2 rounded" />
        </div>
      </CardContent>
    </Card>
  );
};
